import {Alert} from "react-bootstrap";
import {ApiError} from "../api/http";

// The API doesn't explain its errors to browsers (every error body is generic), so the text comes from
// the status code, with page-specific wording where it helps.
const defaults: Record<number, string> = {
    0: "Couldn't reach the server. Check your internet connection and try again.",
    400: "That wasn't accepted. Check the values and try again.",
    401: 'Your session has ended. Please sign in again.',
    403: "You don't have permission to do that.",
    404: "That couldn't be found. It may have been removed.",
    409: 'That conflicts with something that already exists.',
    500: 'Something went wrong on our side. Please try again in a moment.'
};

export function errorMessage(error: unknown, messages?: Record<number, string>): string {
    if (error instanceof ApiError) {
        return messages?.[error.status] ?? defaults[error.status] ?? (error.status >= 500 ? defaults[500] : defaults[400]);
    }
    return error instanceof Error ? error.message : String(error);
}

export function ErrorAlert({error, messages, onClose}: { error: unknown, messages?: Record<number, string>, onClose?: () => void }) {
    if (!error) {
        return null;
    }
    return <Alert variant="danger" dismissible={!!onClose} onClose={onClose}>{errorMessage(error, messages)}</Alert>;
}
